import axios from 'axios';
import { AppUser } from '../../views/App/App';
import { ALL_LIMIT } from '../../consts/table';

export function getJobImages(user: AppUser, jobId: string, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios
    .get(`${window.apiBase}/admin/jobs/${jobId}/images`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllJobImages(user: AppUser, jobId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/jobs/${jobId}/images`, config)
    .then(response => {
      return response.data;
    });
}

export function getJobImagesCount(user: AppUser, jobId: string, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/jobs/${jobId}/images/count`, config)
    .then(response => {
      return response.data;
    });
}

export function updateJobImage(
  user: AppUser,
  jobId: string,
  imageId: string,
  data
) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(
      `${window.apiBase}/admin/jobs/${jobId}/images/${imageId}`,
      data,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function deleteJobImage(user: AppUser, jobId: string, imageId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(`${window.apiBase}/admin/jobs/${jobId}/images/${imageId}`, config)
    .then(response => {
      return response.data;
    });
}
